<template>
  <div>
    <div class="level">

      <div class="columns">

        <div class="column">

          <p class="label is-size-7">
            Estimated sale price
            <b-tooltip
              type="is-info"
              label="What the property is worth in today's market, assuming it's in great condition"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.estimatedMarketValue"
            :options="currency"
          />

          <p class="label is-size-7">
            Hard appraised price
            <b-tooltip
              type="is-info"
              label="What a hard money lender appraises the property for (only needed if doing a hard money loan)"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.estimatedAppraisedValue"
            :options="currency"
          />

          <p class="label is-size-7">
            Purchase price
            <b-tooltip
              type="is-info"
              label="The price you will pay for the property"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.purchasePrice"
            :options="currency"
          />
        </div>

        <div class="column">

          <p class="label is-size-7">
            Seller contribution
            <b-tooltip
              type="is-info"
              label="How much the seller will contribute to your closing costs (this is rare)"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.sellerContribution"
            :options="currency"
          />

          <p class="label is-size-7">
            Survey
            <b-tooltip
              type="is-info"
              label="The cost for a survey"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.survey"
            :options="currency"
          />

          <p class="label is-size-7">
            Appraisal
            <b-tooltip
              type="is-info"
              label="The cost for an appraisal"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.appraisal"
            :options="currency"
          />
        </div>

        <div class="column">

          <p class="label is-size-7">
            Repairs & Make-ready
            <b-tooltip
              type="is-info"
              label="Estimated cost for repairs and getting the property ready to rent"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.repairsMakeReady"
            :options="currency"
          />

          <p class="label is-size-7">
            HOA annually
            <b-tooltip
              type="is-info"
              label="Annual HOA (Home Owners Association) fees"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.hoaAnnual"
            :options="currency"
          />

          <p class="label is-size-7">
            Property tax annually
            <b-tooltip
              type="is-info"
              label="The property tax cost for a year"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.propertyTaxAnnual"
            :options="currency"
          />

        </div>

        <div class="column">

          <p class="label is-size-7">
            Insurance annually
            <b-tooltip
              type="is-info"
              label="The property insurance cost annually"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.propertyInsuranceAnnual"
            :options="currency"
          />

          <p class="label is-size-7">
            Inspection
            <b-tooltip
              type="is-info"
              label="The cost for an inspection of the property"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.inspection"
            :options="currency"
          />

          <p class="label is-size-7">
            Misc. monthly
            <b-tooltip
              type="is-info"
              label="Any monthly costs not already accounted for, for example a property management fee"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.miscellaneousMonthly"
            :options="currency"
          />
        </div>

        <div class="column">

          <p class="label is-size-7">
            Rent
            <b-tooltip
              type="is-info"
              label="The amount of rent to charge monthly"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.rent"
            :options="currency"
          />

          <p class="label is-size-7">
            Max Refi Cashback
            <b-tooltip
              type="is-info"
              label="The maximum cash back allowed on the hard-money refi"
              multilined
            >
              <i class="fas fa-info-circle"></i>
            </b-tooltip>
          </p>
          <vue-autonumeric
            class="input"
            style="text-align: right"
            v-model="$store.state.evaluation.calculator.dealTermInputs.maxRefiCashback"
            :options="currency"
          />

          <p>&nbsp;</p>
          <b-field
            label=""
            custom-class="is-small"
          >
            <button
              class="button is-primary"
              @click="updateCalc($store.state.evaluation)"
            >Update</button>
          </b-field>
        </div>

      </div>
    </div>

    <b-message
      v-if="warningList != ''"
      type="is-warning"
      has-icon
    >
      Please check the following fields for values:<br />{{ warningList }}
    </b-message>

  </div>
</template>

<script>
import store from "@/store";
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  components: {
    store,
    VueAutonumeric
  },

  data() {
    return {
      warningList: "",
      currency: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      }
    };
  },

  methods: {
    updateSaleComps(evaluation) {
      console.log("updateSaleComps()", evaluation);
      store.dispatch("updatePropertyEvaluationSaleComps", evaluation);
    },

    async updateCalc(evaluation) {
      console.log("updateCalc()", evaluation);
      await store.dispatch("updatePropertyEvaluationCalculator", evaluation);
      this.warningList = "";
      if (this.$store.state.evaluation.dealTermWarnings) {
        this.$store.state.evaluation.dealTermWarnings.forEach(element => {
          this.warningList += element + ", ";
        });
        this.warningList = this.warningList.slice(0, -2);
      }
    }
  }
};
</script>

<style>
.label {
  margin-top: 0.5em;
  margin-bottom: 0em !important;
}
</style>
